export default "__VITE_ASSET__1c8f2535__"